import { JourneyComponentDrawer } from './JourneyComponentDrawer'

interface JourneyDrawerProps {
    children: React.ReactNode
    isDraft: boolean
}

export const JourneyDrawer = ({ children, isDraft }: JourneyDrawerProps) => {
    if (children) return <>{children}</>
    return isDraft
        ? <JourneyComponentDrawer />
        : null
}

JourneyDrawer.displayName = 'JourneyDrawer'
